import {
    Autocomplete,
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  createFilterOptions,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Category, Clear } from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../../Masters/dataConfig";

const GroupCategoryMapModal = ({ mode, handleCloseClick, editData }) => {
  const [loading, setLoading] = useState(false);
  const [userGroup, setUserGroup] = useState([]);
  const [notiCat, setNotiCat] = useState([]);


  const OPTIONS_LIMIT = 10;
    const defaultFilterOptions = createFilterOptions();
    const filterOptions = (options, state) => {
      return defaultFilterOptions(options, state);
    };
    const CustomPaper = (props) => {
      return <Paper elevation={8} {...props} />;
    };



  useEffect(() =>{
   getData();
  }, []);
  const getData = async () => {
    const link = masterAPI["userGroup"].link;
    await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        setLoading(false);
        setUserGroup(res.data.result);
      })
      .catch((e) => {
        setUserGroup([]);
        setLoading(false);
        console.log(e, "UserGroup");
      });

      const linkCat =masterAPI["notificationcategory"].link;
      await axiosPrivate
      .get(`${linkCat}`)
      .then((res) =>{
        setLoading(false);
        setNotiCat(res.data.result);
      })
      .catch((e) => {
        setNotiCat([]);
        setLoading(false);
        console.log(e,"notcaterror");
      });
    }

  const initialValue = {
    code: mode === "Edit" ? editData.code : "",
      notificationCategoryId:
      mode === "Edit" ? editData.notificationCategoryId : "",
      userGroupId: mode === "Edit" ? editData.userGroupId : "",
  };

  const onSubmit = async (value) => {
    console.log(value);
    setLoading(true);
    const createLink = masterAPI["usergroupnotificationcategory"].create;
    const updateLink = masterAPI["usergroupnotificationcategory"].update;
    if (mode === "Create") {
      await axiosPrivate
        .post(`${createLink}`, value)
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          console.log(e, "createAC");
        });
    } else {
      const updateAC = {
        id: editData.id,
        ...value,
      };
      await axiosPrivate
        .put(`${updateLink}`, updateAC)
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          console.log(e, "updateAC");
        });
    }
  };

  const handleCancel = () => {
    handleCloseClick();
  };

  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          {mode === "Edit"
            ? "Update User Group Notification Category Mapping"
            : "New User Group Notification Category Mapping"}
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Formik initialValues={initialValue} onSubmit={onSubmit}>
        {({ handleChange, setFieldValue, values, resetForm }) => (
          <Form>
            <Grid container spacing={"1rem"}>
                 <Grid item xs={12} md={6}>
                            <Typography
                                  sx={{
                                    fontWeight: color.labelFontWeight,
                                    mb: color.labelmb,
                                    fontSize: color.labelFont,
                                    color: color.labelColor,
                                  }}
                                >
                        Code
                                </Typography>
                              <Field
                                as={TextField}
                                size={"small"}
                                type="text"
                                name="code"
                                placeholder="Enter Code"
                                fullWidth
                                sx={{
                                  ".MuiInputBase-input": {
                                    // letterSpacing: "0.2rem",
                
                                    "&::placeholder": {
                                      // color: "green",
                                      opacity: 1,
                                      color: color.placeholderColor,
                                      fontSize: "13px",
                                    },
                                  },
                                }}
                              />
                            </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  User Group
                </Typography>
                <Autocomplete
                  fullWidth
                  filterOptions={filterOptions}
                  loading={userGroup.length === 0}
                  options={userGroup}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) => option.userGroupName}
                  value={userGroup.find((p) => p.id === values.userGroupId) || null}
                  freeSolo
                  onChange={(event, value) => {
                    console.log(value);
                    if (value !== null) {
                      setFieldValue("userGroupId", value.id);
                    } else {
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    console.log(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="userGroupId"
                      placeholder="Select User Group"
                      //  onChange={handleChge}
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                            {/* {site.length===0 ? (
                                                            <CircularProgress color="inherit" size={20} />
                                                          ) : null} */}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Notification Category
                </Typography>
                <Autocomplete
                  fullWidth
                  filterOptions={filterOptions}
                  loading={notiCat.length === 0}
                  options={notiCat}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) => option.categoryName}
                  value={notiCat.find((p) => p.id === values.notificationCategoryId) || null}
                  freeSolo
                  onChange={(event, value) => {
                    console.log(value);
                    if (value !== null) {
                      setFieldValue("notificationCategoryId", value.id);
                    } else {
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    console.log(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="notificationCategoryId"
                      placeholder="Select Notification Category"
                      //  onChange={handleChge}
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                            {/* {site.length===0 ? (
                                                            <CircularProgress color="inherit" size={20} />
                                                          ) : null} */}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid
                container
                item
                xs={12}
                justifyContent={"flex-end"}
                gap="1rem"
              >
                <Button
                  onClick={handleCancel}
                  variant="contained"
                  sx={{
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                    ":hover": {
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type={"submit"}
                  variant="contained"
                  disabled={loading}
                  sx={{
                    textTransform: "none",
                    backgroundColor: loading
                      ? "default"
                      : color.TableButtonColor,
                    "&:hover": {
                      backgroundColor: loading
                        ? "default"
                        : color.buttonDisable,
                    },
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default GroupCategoryMapModal;
